import React from "react";
import { CollectionName } from "../../atoms/collection-name";
import CommonCollectionCard from "../../molecules/common-collection-card";
import HindiColumnCard from "../../molecules/hindi-column-card"
import getStoriesByCollection from "../../../utils";

import "./three-hindi-columns.m.css"

export function ThreeHindiColumns({collection, config}){
  
    const collections = collection.items.filter(collection => collection.type === "collection");
    
    return(
        <div className="full-width-with-padding" styleName="inner-wrapper">
            <div className="container">
                <CollectionName collection={collection} color="#fff" />
                
                <div styleName="wrapper">
                    {collections.map(item=>{
                        return(                   
                            <HindiColumnCard collection={item} key={item.id}/>                        
                        )
                    })}
                    
                </div>

            </div>
        </div>
    )
}